import { render, staticRenderFns } from "./ItemOff.vue?vue&type=template&id=3c030397&scoped=true&"
import script from "./ItemOff.vue?vue&type=script&lang=js&"
export * from "./ItemOff.vue?vue&type=script&lang=js&"
import style0 from "./ItemOff.vue?vue&type=style&index=0&id=3c030397&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c030397",
  null
  
)

export default component.exports